module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "cast"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CAST")])]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("GEORGE")]), _vm._v(", male, 40s.")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIONA")]), _vm._v(", female, 40s.")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANNA")]), _vm._v(", female, 15. Anna is considerably overweight.")]), _vm._v(" "), _c('p', {
    staticClass: "s"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TERRY")]), _vm._v(", male, 20s.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Ellipses following a character’s name indicate a desire to speak but an inability to know quite what to say.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18654304","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cast-list.vue
// module id = 81
// module chunks = 0